<template>
  <v-menu
    v-model="menu"
    offset-y
    :close-on-content-click="false"
    :max-width="280"
    :nudge-top="21"
    :nudge-left="-28"
  >
    <template #activator="{ on, attrs }">
      <v-input
        v-on="on"
        v-bind="attrs"
        :class="['v-text-field', { 'v-input--is-focused': menu }]"
      >
        <template #prepend>
          <v-icon class="mt-1">calendar_today</v-icon>
        </template>
        <div
          class="v-text-field__slot d-flex align-center"
          :style="`height: 40px; transform(1)`"
        >
          <span
            v-if="!dateRange.start && !dateRange.end"
            class="text--disabled"
          >
            Pick a date range
          </span>
          <div v-else class="d-flex align-center flex-grow-1 flex-shrink-0">
            <span>
              {{ dateRange.start ? format(dateRange.start) : "" }}
            </span>
            <v-btn
              v-if="dragging"
              small
              color="accent"
              class="ml-3"
              @click.prevent.stop="datePickerEndless()"
            >
              Onward
            </v-btn>
            <template v-else-if="!isSameDay">
              <template v-if="dateRange.end">
                <v-icon class="mx-1">chevron_right</v-icon>
                <span>{{ format(dateRange.end) }}</span>
              </template>
              <span v-else class="ml-3 text--secondary">Onward</span>
            </template>
            <span v-else class="ml-3 text--secondary">Only</span>
          </div>
        </div>
        <div v-if="!isNull" class="v-input__append-inner">
          <v-btn icon @click.stop="handleClearClicked()">
            <v-icon>clear</v-icon>
          </v-btn>
        </div>
      </v-input>
    </template>
    <v-card>
      <vc-date-picker
        ref="datePicker"
        :value="dateRange"
        :key="menu"
        :from-date="dateRange?.start"
        mode="date"
        is-range
        is-expanded
        :local="locale"
        :min-date="new Date().setDate(new Date().getDate() - 1)"
        :popover="{ visibility: 'click' }"
        @input="handleInput"
        @dayclick="handleDayClicked"
        @drag="handleDateRangeDragged"
      />
    </v-card>
  </v-menu>
</template>
<script>
import moment from "moment";

export default {
  props: {
    value: Object,
  },
  emits: ["input"],
  data() {
    return {
      menu: false,
      dragging: false,
      dateClickCount: 0,
      locale: window.navigator.userLanguage || window.navigator.language,
    };
  },
  computed: {
    /**
     * computed prop for the model value of the date picker,
     *
     * Type: Date, Object
     *
     * {@link https://v2--vcalendar.netlify.app/api/v2.0/datepicker.html#value Date Picker API}
     */
    dateRange: {
      get() {
        if (!this.value) {
          return {
            start: null,
            end: null,
          };
        }

        return {
          start: this.value.start != null ? new Date(this.value.start) : null,
          end: this.value.end != null ? new Date(this.value.end) : null,
        };
      },
      set(val) {
        if (!val) {
          this.$emit("input", null);
          return;
        }

        this.$emit("input", {
          start:
            val.start != null
              ? moment(val.start).format("YYYY-MM-DD[T00:00:00]")
              : null,
          end:
            val.end != null
              ? moment(val.end).format("YYYY-MM-DD[T00:00:00]")
              : null,
        });
      },
    },
    isNull() {
      return !this.value?.start && !this.value?.end;
    },
    isSameDay() {
      if (!this.value || !this.value.start || !this.value.end) {
        return false;
      }

      return this.format(this.value.start) === this.format(this.value.end);
    },
  },
  methods: {
    handleInput(val) {
      this.dragging = false;
      this.menu = false;
      this.dateRange = val;
    },
    handleDayClicked(val) {
      const count = this.dateClickCount % 2;

      if (count === 0) {
        this.dateRange = {
          start: val.range.start,
          end: val.range.end,
        };
      }

      this.dateClickCount++;
    },
    handleClearClicked() {
      this.dateRange = null;
    },
    handleDateRangeDragged() {
      this.dragging = true;
    },
    datePickerEndless() {
      this.menu = false;
      this.dragging = false;

      this.dateRange = {
        ...this.dateRange,
        end: null,
      };
    },
    format(time) {
      return moment(time).format("L");
    },
  },
  watch: {
    menu: function (val) {
      if (val) {
        setTimeout(() => {
          if (this.dateRange?.start && !this.dateRange?.end) {
            this.$refs.datePicker?.focusDate(this.dateRange.start);
          }
        }, 300);
      } else {
        this.dragging = false;
        this.dateClickCount = 0;
      }
    },
  },
};
</script>
